import Rebase from 're-base'
import firebase from 'firebase'

// prod
const config = {
  apiKey: "AIzaSyAsaD_wmfc_KjdaauC8y-QOownlGXUPPtE",
  authDomain: "alerta-celular-bf25d.firebaseapp.com",
  databaseURL: "https://alerta-celular-bf25d.firebaseio.com",
  projectId: "alerta-celular-bf25d",
  storageBucket: "alerta-celular-bf25d.appspot.com",
  messagingSenderId: "731242484939"
};

const app = firebase.initializeApp(config)
const base = Rebase.createClass(app.database())

export const auth = firebase.auth()

export const handleRecoverEmail = (auth, email) => {

}
export const handleResetPassword = (auth, email) => {

  auth.verifyPasswordResetCode(email).then((email) => {


  }).catch((err) => {})
}

export default base


// WEBPACK FOOTER //
// ./src/services/Firebase.js